import axios from 'axios'

const state = {
    list: [],
    rates: [],
    load: true,
    dataUploaded: false,
    error: false,
    errorText: '',
};
const mutations = {
    add(state, item) {
        state.list.push(item);
    },
    err(state, text) {
        state.error = true;
        state.errorText = text;
        state.load = false;
        state.dataUploaded = false;
    }
};
const actions = {
    get_list(context) {
        if (context.state.dataUploaded) return;
        context.state.load = true;
        context.state.dataUploaded = true;
        axios({
            method: 'post',
            url: '/tourclient/masterAgent/dictionary/currency/list',
            data: {
                request: JSON.stringify({"removeZero": true, "Full": true, "RetrieveMappings": true, "IsUnused": false}),
                removeZero: true,
            }
        }).then(r => {
            if (r.data.ResultQueryInfo.HasError) {
                context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
                return;
            }
            r.data.Items.forEach(item => {
                if (item.IsUnused === false) {
                item.value = item.Id;
                item.label = item.Name;
                context.commit('add', item);
            }
            });
            context.state.load = false;
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    },
};
const getters = {
    national: state => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.IsNational;
        })[0];
    },
    getById: (state, getters) => id => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.value === id;
        })[0] || {};
    },
    getIso: (state, getters) => id => {
        if (!state.list.length) return null;
        let a = state.list.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.IsoCode : '';
    },
    getName: (state, getters) => id => {
        if (!state.list.length) return null;
        let a = state.list.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.Name : '';
    },
    rate: (state) => (date, c1, c2) => {
        if (c1 === c2) return {date: date, c1: c1, c2: c2, course: 1};
        return state.rates.filter(i => {
            return date === i.date && c1 === i.c1 && c2 === i.c2;
        })[0];
    },
    load_retes: state => {
        return !!state.rates.filter(i => {
            return !i.course
        })[0];
    }

};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
